import React from 'react';
const AdminTestimonials = () => <div className="min-h-screen p-8">Admin Testimonials Management</div>;
export default AdminTestimonials; 